import React from 'react';
import Icon from '../ui/Icon';

const menuItem = { display: 'flex', alignItems: 'center', gap: 12, width: '100%', padding: '10px 16px', background: 'transparent', border: 'none', color: '#2D3748', fontSize: 13, fontWeight: 500, cursor: 'pointer', textAlign: 'left', transition: 'background 0.12s' };

export default function ProfileDropdown({ onClose, userProfile, onOpenSettings, onOpenOutOfOffice, onOpenAppearance, onLogout }) {
  return (
    <div style={{ position: 'absolute', right: 0, marginTop: 8, width: 270, background: '#FFFFFF', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.5)', border: '1px solid #DDE1E7', zIndex: 50 }}>
      {/* Profile Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', borderBottom: '1px solid #DDE1E7' }}>
        <div style={{ flexShrink: 0, width: 40, height: 40, borderRadius: '50%', background: '#DDE1E7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: 'var(--accent)', fontSize: 15, overflow: 'hidden', border: '1.5px solid #C8CDD6' }}>
          {userProfile.avatar
            ? <img src={userProfile.avatar} alt="Avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : userProfile.name.charAt(0)
          }
        </div>
        <div style={{ flex: 1, overflow: 'hidden' }}>
          <div style={{ fontWeight: 700, color: '#1A202C', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{userProfile.name}</div>
          <div style={{ color: '#718096', fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginBottom: 4 }}>{userProfile.email}</div>
          <button onClick={onOpenSettings} style={{ background: 'none', border: 'none', color: 'var(--accent)', fontSize: 11, fontWeight: 600, cursor: 'pointer', padding: 0 }}>Profile settings</button>
        </div>
      </div>

      {/* Menu */}
      <div style={{ padding: '6px 0' }}>
        <button onClick={onOpenOutOfOffice} style={menuItem}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--accent-bg)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
          <Icon name="clock" size={15} color="#718096" /><span>Manage out-of-office hours</span>
        </button>
        <button onClick={onOpenAppearance} style={{ ...menuItem, justifyContent: 'space-between' }}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--accent-bg)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}><Icon name="moon" size={15} color="#718096" />Appearance</span>
          <Icon name="chevronR" size={12} color="#718096" />
        </button>
      </div>

      {/* Sign out */}
      <div style={{ padding: '6px 0', borderTop: '1px solid #DDE1E7' }}>
        <button onClick={onLogout} style={{ ...menuItem, color: '#f87171' }}
          onMouseEnter={e => e.currentTarget.style.background = '#FFF5F5'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
          <Icon name="logout" size={15} color="#f87171" /><span>Sign out</span>
        </button>
      </div>
    </div>
  );
}
